import { getDataFromList } from '@/core/item_assistance/receiveDataFromComponents'
import { booleanStringValueToLogicalBoolean, isCorrectData } from '@/core/shared'
import { setSingleTextValueIntoFilters } from '@/core/filters/initializeFiltersData'

function getSingleTextValueFromFilters (id) {
	return $('#' + id).find('input').val()
}

function getMultipleTextValueFromFilters (id) {
	return $('#' + id).find('textarea').val()
}

function getSingleDateValueFormFilters (id, index) {
	return $('#' + id).find('input').eq(index).val()
}

function getSingleListValueFromFilters (id) {
	return $('#' + id + ' select option:selected').attr('value')
}

function getListValueFromFilters (id) {
	var i = 0
	var result = []

	while (true) {
		var newValueFromList = getDataFromList('list__' + id + '__' + i, null)
		if (newValueFromList == undefined) break
		if (!_.isEmpty(newValueFromList)) {
			result.push(newValueFromList)
		}
		i++
	}

	return !_.isEmpty(result) ? result : null
}

function getItemStatusValue (id) {
	var status = {}
	_.each($('#' + id).find('.status-filter-element'), function (statusElement) {
		var selectedStatus = $(statusElement).find('button.selected').first()[0]
		if (selectedStatus) {
			status[$(statusElement).attr('data-name')] = selectedStatus.classList.contains('complete-status')
		}
	})
	return status
}

function getListWithoutBlankValuesFromString (valuesString, delimeter) {
	var res = []
	if (valuesString) {
		var values = valuesString.split(delimeter)
		_.each(values, function (value, key) {
			if (isCorrectData(value)) {
				res.push(value)
			}
		})
	}
	return res
}

export function routerForReceiveDataFromFilters (attributeType, attributeName, isMultiple) {
	var node = {}

	if (attributeType == 'S' || attributeType == 'SL') {
		if (!isMultiple) {
			var value = getSingleTextValueFromFilters(attributeName)
			if (isCorrectData(value)) {
				node['val'] = value
				node['type'] = attributeType
			}
		} else {
			var valuesString = getMultipleTextValueFromFilters(attributeName)
			var values = getListWithoutBlankValuesFromString(valuesString, '\n')
			if (!_.isEmpty(values)) {
				node['val'] = values
				node['type'] = attributeType
			}
		}
	}
	if (attributeType == 'N') {
		if (!isMultiple) {
			var value = parseFloat(getSingleTextValueFromFilters(attributeName))
			if (isCorrectData(value) && $.isNumeric(value)) {
				node['val'] = value
				node['type'] = attributeType
			} else {
				setSingleTextValueIntoFilters(attributeName, '')
			}
		} else {
			var values = getMultipleTextValueFromFilters(attributeName).split('\n')
			var resultValues = []
			_.each(values, function (val) {
				val = parseFloat(val)
				if (isCorrectData(val) && $.isNumeric(val)) {
					resultValues.push(val)
				}
			})

			setMultipleTextValueIntoFilters(attributeName, resultValues)
			if (!_.isEmpty(resultValues)) {
				node['val'] = resultValues
				node['type'] = attributeType
			}
		}
	}
	if (attributeType == 'L') {
		if (!isMultiple) {
			var value = getListValueFromFilters(attributeName)
			if (isCorrectData(value)) {
				node['val'] = value
				node['type'] = attributeType
			}
		} else {
			//code for multiple attribute receive
		}
	}
	if (attributeType == 'B' || attributeType == 'A') {
		if (!isMultiple) {
			var value = getSingleListValueFromFilters(attributeName)
			if (isCorrectData(value)) {
				node['val'] = booleanStringValueToLogicalBoolean(value)
				node['type'] = attributeType
			}
		} else {
			//code for multiple attribute receive
		}
	}
	if (attributeType == 'D') {
		if (!isMultiple) {
			var startDate = getSingleDateValueFormFilters(attributeName, 0)
			var endDate = getSingleDateValueFormFilters(attributeName, 1)
			if (isCorrectData(startDate)) {
				node['from'] = startDate
				node['type'] = attributeType
			}
			if (isCorrectData(endDate)) {
				node['to'] = endDate
				node['type'] = attributeType
			}
		} else {
			//code for multiple attribute receive
		}
	}
	if (attributeType == 'NM') {
		if (!isMultiple) {
			var value = parseFloat(getSingleTextValueFromFilters(attributeName))
			var listValue = getSingleListValueFromFilters(attributeName)
			if (isCorrectData(value) && $.isNumeric(value)) {
				node['val'] = value
				node['type'] = attributeType
			} else {
				setSingleTextValueIntoFilters(attributeName, '')
			}
			if (isCorrectData(listValue)) {
				node['mu'] = listValue
				node['type'] = attributeType
			}
		} else {
			//code for multiple attribute receive
		}
	}
	if (attributeType == 'status') {
		node = getItemStatusValue(attributeName)
	}

	return node
}
